import React from "react";
import { EditDate, CheckBox } from "Application";
import { Input } from "Components";
import { AttendanceField, SelectBox, TableFilter } from "./SessionReport.styles";
import { ThemedEditSelect } from "Styles/ThemedPrimitives/Style1/ThemeEditSelect";
import { convertTimeToDate } from "Views/Students/Student/StudentReports/Utils/ConvertTimeToDate";
import { observer } from "mobx-react-lite";
import { IStudentSessionReportViewModel } from "Views/Students/Student/StudentReports/Form/Interfaces/IStudentSessionReportViewModel";

export const SessionReportForm: React.FC<{ viewModel: IStudentSessionReportViewModel }> = observer(({ viewModel }) => {
    const timeValue = (val: unknown) => {
        if (val instanceof Date) return val;
        return convertTimeToDate(val as string | null | undefined);
    };
    return (
        <>
            <TableFilter>
                <EditDate
                    displayName={"Date of session"}
                    maxDate={new Date()}
                    value={() => viewModel.getValue("sessionDate")}
                    command={viewModel.updateSessionDateCommand}
                    mode="date"
                    disableWeekends={true}
                    isRequired
                />
                <EditDate
                    displayName={"Start time of session"}
                    value={() => timeValue(viewModel.getValue("sessionStartTime"))}
                    command={viewModel.updateSessionStartTimeCommand}
                    mode="time"
                    dateFormat={"HH:mm"}
                    validationMessage={() => viewModel.getError("sessionStartTime")}
                    isRequired
                />
                <EditDate
                    displayName={"End time of session"}
                    value={() => timeValue(viewModel.getValue("sessionEndTime"))}
                    command={viewModel.updateSessionEndTimeCommand}
                    mode="time"
                    dateFormat={"HH:mm"}
                    validationMessage={() => viewModel.getError("sessionEndTime")}
                    isRequired
                />
                {viewModel.renderForm && (
                    <ThemedEditSelect
                        displayName={"Activity"}
                        placeholder={"Type name of activity or add a new one"}
                        command={viewModel.updateActivityTypeCommand}
                        options={viewModel.getActivity}
                        value={() => viewModel.getValue("activityTypeId")}
                        validationMessage={() => viewModel.getError("activityTypeId")}
                        isCreatable={true}
                        isRequired
                    />
                )}
                {!viewModel.renderForm && viewModel.showAbsenceFields && (
                    <ThemedEditSelect
                        displayName={"Reason for absence"}
                        placeholder={"Select a reason"}
                        command={viewModel.updateAbsenceReasonCommand}
                        options={viewModel.getAbsenceReasons}
                        value={() => viewModel.studentAbsenceViewModel.getValue("absenseTypeId")}
                        validationMessage={() => viewModel.studentAbsenceViewModel.getError("absenseTypeId")}
                        isRequired
                    />
                )}
                <AttendanceField display={"flex"} alignContent={"flex-end"} style={{ gap: "30px" }}>
                    <SelectBox backgroundColor={viewModel.displayStatus}>
                        <ThemedEditSelect
                            displayName={"Attendance"}
                            placeholder={""}
                            command={viewModel.updateSessionStatusCommand}
                            options={viewModel.attendanceOptions}
                            value={() => viewModel.getValue("attendance")}
                            validationMessage={() => viewModel.getError("attendance")}
                            isRequired
                        />
                    </SelectBox>
                    {viewModel.renderForm && (
                        <CheckBox
                            command={viewModel.updateReportIncidentCommand}
                            value={() => viewModel.getValue("reportIncident")}
                            displayName="Report incident"
                            validationMessage={() => viewModel.getError("reportIncident")}
                        />
                    )}
                </AttendanceField>
            </TableFilter>
            {viewModel.showAbsenceFields && viewModel.showOtherAbsenceText && (
                <Input
                    multiline={true}
                    rows={4}
                    displayName="Please give more detail"
                    validationMessage={() => viewModel.studentAbsenceViewModel.getError("reason")}
                    command={viewModel.updateAbsenceReasonDetailCommand}
                    value={() => viewModel.studentAbsenceViewModel.getValue("reason")}
                    placeholder="Please add notes..."
                />
            )}
        </>
    );
});
